import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionDeclinedOpsDialogData } from './action-declined-ops-data.model';

@Component({
  selector: 'action-declined-ops-dialog',
  templateUrl: './action-declined-ops-dialog.component.html',
  styleUrls: ['./action-declined-ops-dialog.component.css'],
})
export class ActionDeclinedOpDialogComponent implements OnInit {
  actionDeclinedOpsForm: FormGroup = this.formBuilder.group({
    actionTypeId: [null, [Validators.required]],
  });

  constructor(@Inject(MAT_DIALOG_DATA) public data: ActionDeclinedOpsDialogData, private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.actionDeclinedOpsForm.markAllAsTouched();
  }
}
